/**
 * 404 · Página no encontrada · Alfa-Field Connect (v3.9.1)
 */
import { Link } from "react-router-dom";
import { ArrowLeft, MapPinOff } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-white">
      <div className="text-center max-w-lg" data-testid="not-found-page">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#E6EDEF] text-[#0A3747] mb-6 shadow-inner">
          <MapPinOff size={44} strokeWidth={1.5} />
        </div>
        <h1 className="text-3xl font-black text-[#0A3747] mb-2">404 · Ruta no encontrada</h1>
        <p className="text-slate-600 text-sm mb-6 leading-relaxed">
          La página que buscas no existe o fue reubicada. Revisa el enlace o
          vuelve al dashboard principal.
        </p>
        <Link
          to="/dashboard"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#0A3747] text-[#E0E621] rounded-lg text-sm font-bold hover:bg-[#135166] transition shadow-lg"
          data-testid="not-found-back"
        >
          <ArrowLeft size={15} /> Volver al Dashboard
        </Link>
        <p className="mt-6 text-[10px] uppercase tracking-widest text-slate-400">
          Alfa-Field Connect · TELEALFACOM S.A.
        </p>
      </div>
    </div>
  );
}
